import { INITIALIZE_REASIGN_FORM } from '../actionTypes';
import { contactActions } from '../reducer';

export default (values) => contactActions[INITIALIZE_REASIGN_FORM](values);
